var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4261 31.521C8.39153 31.8795 7.03399 33.8161 7.39179 35.8506C7.7099 37.6646 9.28675 38.9415 11.0684 38.9415C11.2838 38.9415 11.501 38.9225 11.72 38.8838L13.8759 38.5056V46.2618C13.8759 48.3247 15.5502 50 17.614 50C19.6788 50 21.3525 48.3247 21.3525 46.2618V37.1915L28.0213 36.0182V43.9255C28.0213 45.9903 29.6968 47.6636 31.7601 47.6636C33.8243 47.6636 35.4983 45.9903 35.4983 43.9255V34.7061L40.0701 33.8997C42.1034 33.5443 43.4621 31.6066 43.1053 29.5733C42.748 27.5374 40.8089 26.1813 38.7756 26.5388L35.497 27.1146V19.3525L39.572 18.6363C41.6053 18.2783 42.9633 16.3402 42.6052 14.3069C42.2499 12.2733 40.3084 10.9187 38.2762 11.2725L35.4968 11.7606V3.73816C35.4967 1.67369 33.8226 0 31.7585 0C29.6952 0 28.0197 1.67369 28.0197 3.73816V13.0748L21.3509 14.2465V6.07371C21.3509 4.0099 19.6772 2.33523 17.6126 2.33523C15.5488 2.33523 13.8744 4.0099 13.8744 6.07371V15.5616L9.92772 16.2553C7.8928 16.6133 6.53559 18.5513 6.89306 20.5843C7.21085 22.3983 8.7877 23.6768 10.57 23.6768C10.7852 23.6768 11.0019 23.6568 11.2207 23.6191L13.8744 23.1529V30.9156L10.4261 31.521ZM21.3509 21.8401L28.0197 20.6684V28.4289L21.3509 29.6011V21.8401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIconWhite);
export default __webpack_public_path__ + "static/media/numberIcon-white.a6911cfe6d912d3e86276210f29e806f.svg";
export { ForwardRef as ReactComponent };